import { Stack } from '@mui/material';
import React from 'react';
import { IForm } from './interface';

export const Form: React.FC<IForm> = ({
  id,
  children,
  onSubmit,
}): JSX.Element => {
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    onSubmit();
  };

  return (
    <Stack gap="15px" component="form" id={id} onSubmit={handleSubmit}>
      {children}
    </Stack>
  );
};
